import type { ProductType } from '../api/business/types';

/** The product types the back office offers, in its order (R0030 WP-09, WP-10). */
export const PRODUCT_TYPES: Array<ProductType> = ['STANDARD', 'PACK', 'VIRTUAL'];
